/**
 * Eine gemischte Reihenfolge der Positionen `0 … count-1` — ein Durchgang zeigt jede einmal.
 *
 * Reiner Zufall pro Wechsel wiederholt sich oft sichtbar; mit einem Durchgang kommt jedes Beispiel dran.
 * `last` ist die zuletzt gezeigte Position des vorigen Durchgangs: Die neue Reihenfolge beginnt nie mit ihr,
 * sonst stünde an der Rundengrenze zweimal derselbe Text.
 */
export function shuffledOrder(count: number, last: number | null, random: () => number = Math.random): number[] {
  const order = Array.from({ length: count }, (_, i) => i)
  for (let i = count - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1))
    ;[order[i], order[j]] = [order[j]!, order[i]!]
  }
  if (count > 1 && order[0] === last) [order[0], order[count - 1]] = [order[count - 1]!, order[0]!]
  return order
}
